export default __webpack_public_path__ + "static/media/IMG20.2e69f593.jpg";